import { j as l } from "./jsx-runtime-721af1ab.js";
import { useQuery as f } from "@tanstack/react-query";
import { createContext as m, useState as p, useEffect as d } from "react";
import { j as C } from "./useAccount-9a3d6a50.js";
import "./myasurion-shared.mixpanel.es.js";
import { g as F } from "./domains-6461a203.js";
const x = m({
  features: null,
  isInitialized: !1
}), z = ({
  config: e,
  children: r
}) => {
  const [a, s] = p(!1), i = F(), { data: u, refetch: o } = f({
    queryKey: ["featureConfigData", e],
    queryFn: () => {
      var t;
      return C(
        e,
        `feature_flag_${i}_${(t = e == null ? void 0 : e.env) == null ? void 0 : t.toLowerCase()}`
      ).then((n) => JSON.parse(n ?? "{ partnerId: 'asurion' }")).catch(() => null).finally(() => s(!0));
    },
    enabled: !1
  });
  return d(() => {
    e && o();
  }, [e]), /* @__PURE__ */ l.jsx(
    x.Provider,
    {
      value: { features: u, isInitialized: a },
      children: r
    }
  );
};
export {
  z as F,
  x as a
};
